module.exports = __webpack_public_path__ + "img/pin-green-diamond.3d386eb7.png";